import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Note: StrictMode disabled temporarily to fix tester/bonus duplicate calls
// TODO: Re-enable StrictMode after implementing proper state management
root.render(
  <App />
);

